/**
 * QuoteDiscountTvaRow.jsx — Wave 1u3 refactor step 2 (FE).
 *
 * Row with three pricing controls extracted from QuoteFormDialog:
 *   • Discount type (none/percent/amount) + value
 *   • Editable TVA rate
 *   • Validity date / invoice due date
 */
import React from 'react';
import { Percent, Euro } from 'lucide-react';

export default function QuoteDiscountTvaRow({
  discountType, onDiscountTypeChange,
  discountValue, onDiscountValueChange,
  tvaRate, onTvaRateChange,
  validUntil, onValidUntilChange, joursParDefaut,
  isInvoice,
}) {
  return (
    <section className="grid grid-cols-3 gap-3" data-testid="quote-pricing-row">
      <div>
        <label className="block text-[11.5px] font-semibold text-[#6B6C85] uppercase tracking-wide mb-1.5">Remise</label>
        <div className="flex gap-1.5">
          <select
            value={discountType}
            onChange={(e) => onDiscountTypeChange(e.target.value)}
            data-testid="quote-discount-type"
            className="h-10 px-2 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[12.5px] focus:bg-white focus:border-[#4F46E5] outline-none"
          >
            <option value="none">Aucune</option>
            <option value="percent">%</option>
            <option value="amount">€</option>
          </select>
          <div className="relative flex-1">
            <input
              type="number" step="0.01" min="0"
              value={discountValue}
              onChange={(e) => onDiscountValueChange(e.target.value)}
              disabled={discountType === 'none'}
              data-testid="quote-discount-value"
              className="w-full h-10 px-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[12.5px] text-right focus:bg-white focus:border-[#4F46E5] outline-none disabled:opacity-50"
            />
            <span className="absolute right-2.5 top-1/2 -translate-y-1/2 text-[#8E8FA5]">
              {discountType === 'percent' ? <Percent className="w-3.5 h-3.5" /> : discountType === 'amount' ? <Euro className="w-3.5 h-3.5" /> : null}
            </span>
          </div>
        </div>
      </div>
      <div>
        <label className="block text-[11.5px] font-semibold text-[#6B6C85] uppercase tracking-wide mb-1.5">TVA</label>
        <div className="relative">
          <input
            type="number" step="0.1" min="0" max="100"
            value={tvaRate}
            onChange={(e) => onTvaRateChange(e.target.value)}
            data-testid="quote-tva-rate"
            className="w-full h-10 px-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[12.5px] text-right focus:bg-white focus:border-[#4F46E5] outline-none"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-[#8E8FA5] text-[11px]">%</span>
        </div>
      </div>
      <div>
        <label className="block text-[11.5px] font-semibold text-[#6B6C85] uppercase tracking-wide mb-1.5">
          {isInvoice ? 'Échéance de paiement' : 'Validité (jusqu\'au)'}
        </label>
        <input
          type="date"
          value={validUntil}
          onChange={(e) => onValidUntilChange(e.target.value)}
          data-testid="quote-valid-until"
          className="w-full h-10 px-3 rounded-xl bg-[#F6F7FB] border border-[#EFF0F6] text-[12.5px] focus:bg-white focus:border-[#4F46E5] outline-none"
        />
        {/* Ce champ attend une **date**, et on pense en **jours nets** : on
            tapait « 30 » et il refusait. On n'a pas a le remplir — le serveur
            pose la date depuis le delai des parametres. La regle est dite ici,
            le calcul n'est pas refait : une seule definition. */}
        {!validUntil && (
          <p className="text-[11px] text-[#8E8FA5] mt-1">
            {joursParDefaut === null
              ? "Laissez vide : votre délai des paramètres s'applique."
              : joursParDefaut === 0
                ? (isInvoice
                    ? 'Laissez vide : la facture est due à réception.'
                    : "Laissez vide : le devis expire le jour de son émission.")
                : isInvoice
                  ? `Laissez vide : ${joursParDefaut} jours nets depuis la date d'émission.`
                  : `Laissez vide : valable ${joursParDefaut} jours à compter de la date du devis.`}
          </p>
        )}
      </div>
    </section>
  );
}
